import React from 'react';
import Seo from '@site/components/seo';
import Home from '@site/components/home/home';

const HomePage = () => (
  <div>
    <Seo title="首页" />
    <Home />
  </div>
);

export default HomePage;
